export default {
//   apiUrl: 'http://test.api.kahin.online:3000',
//     apiUrl: 'http://localhost:3000/',
     apiUrl: 'https://vodafone-kahin-ai-827e4.hq.spicaengine.com/api/fn-execute',
};
